import customSelect from './custom-select';

window.customSelect = customSelect;
